:host {
  overflow: hidden;
  --color: var(--stzh-breadcrumb-color, #{$colorPrimary70});

  @media print {
    display: none;
  }

  &[variant="teaser"] {
    --color: #{$colorGrey80};
  }
}

.stzh-breadcrumb {
  @include fontSize('milli');
  color: var(--color);

  &__list,
  &__item,
  &__item-link {
    display: flex;
    align-items: center;
  }

  &__list {
    list-style: none;
    margin: 0;
    padding: 0;
    white-space: nowrap;
  }

  &__item.is-expand &__item-link {
    cursor: pointer;
  }

  &__item.is-hidden {
    position: absolute;
    visibility: hidden;
  }

  &__item.is-last &__item-link {
    @include font('heavy');
  }

  &__item.is-first &__item-label {
    @include visuallyhidden;
  }

  &__item-link {
    appearance: none;
    background-color: transparent;
    border: none;
    text-decoration: none;
    color: inherit;
  }

  &__item-link.is-link {
    cursor: pointer;
    transition: color $baseTransitionAnimationSpeed;

    &:hover {
      color: $colorPrimary90;
    }
  }

  &__item-icon {
    margin-right: space('xxsmall');

    &.is-separator {
      --size: #{iconSize('small')};
    }
  }

  &__item-label-hidden {
    @include visuallyhidden;
  }

  /* Expanded variant */

  &--is-expanded &__list {
    flex-wrap: wrap;
    white-space: initial;
  }

  &--is-expanded .is-expand {
    position: absolute;
  }

  /* Teaser variant */

  &--teaser {
    @include fontSize('micro');
  }
}
